/* eslint-disable comma-dangle */
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useDebouncedCallback } from 'use-debounce'
import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid, Avatar } from '@material-ui/core'
import { setChatUser } from '../../../modules/chatCategory/actions'
import c from 'classnames'
import moment from 'moment'
import MinusIcon from '../../../assetss/img/Minus.svg'
import PlusIcon from '../../../assetss/img/Plus.svg'
import './index.scss'

const ChatAccordion = ({ title, id, panel, controls, goTo, page, user, discusStory, avtor, path, description }) => {
  const [expanded, setExpanded] = useState(panel)
  const { message } = useSelector(state => state)
  const { chatUser } = useSelector(({ chat }) => chat)
  const dispatch = useDispatch()
  const history = useHistory()

  const handleChange = panel => (event, newExpanded) => setExpanded(newExpanded ? panel : false)

  const debounced = useDebouncedCallback(
    item => {
      dispatch(setChatUser(item))
    }, 500
  )

  useEffect(() => {
    if (message?.openChat) {
      setExpanded(message?.openChat)
    }
  }, [message?.openChat])

  const goToChatCategory = path => {
    if (path === 'scheduled') {
      history.push('/chat/meeting-scheduled')
    } else if (path === 'request') {
      history.push('/chat/meeting-requests')
    } else if (path === 'meeting') {
      history.push('/chat/meeting-chat')
    }
  }

  return (
    <div className='wrapperAcordion'>
      <Accordion square expanded={expanded === panel} onChange={handleChange(panel)}>
        <AccordionSummary
          onClick={() => history.push(`/chat/${path}`)}
          expandIcon={expanded === panel ? <img className='iconActionsMinus' src={MinusIcon} /> : <img className='iconActionsAcordion' src={PlusIcon} />}
          aria-controls={controls}
          id={id}
        >
          <Typography className='chatCategoryTitle'>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails className='chatBlockAcordion'>
          <Grid container direction='column' wrap='nowrap' className='chatsBlockUsers'>
            {user?.length ? (
              user?.map(i => (
                <Grid
                  container
                  justify='space-between'
                  alignItems='center'
                  key={i?.uuid}
                  className={c('userMassage', chatUser?.uuid === i?.uuid && 'userMessageActive')}
                  onClick={() => {
                    debounced(i)
                    goToChatCategory(i?.status)
                  }}
                  wrap='nowrap'
                >
                  <Avatar className='userAvatar'>
                    {avtor === i.users?.[0]?.uuid ? i.users?.[1]?.name?.substr(0, 1) : i.users?.[0]?.name?.substr(0, 1)}
                  </Avatar>
                  <Grid container direction='column' className='userDetails' justify='space-between' wrap='nowrap'>
                    <Grid container justify='space-between' style={{ width: '100%' }}>
                      <Typography className='userName'>
                        {avtor === i.users?.[0]?.uuid ? i?.users?.[1]?.name : i?.users?.[0]?.name}
                      </Typography>
                      <Typography className='userDateMassage'>
                        {moment(new Date(+i?.lastMessage?.time)).format('hh:mm A')}
                      </Typography>
                    </Grid>
                    <Grid container justify='space-between' alignItems='center'>
                      <Typography className='userMassageText'>{i?.lastMessage?.text}</Typography>
                      {i?.unreadCount ? <Grid className='userActiveDote'>{i?.unreadCount}</Grid> : null}
                    </Grid>
                  </Grid>
                </Grid>
              ))
            ) : <span className='notChatItem'>{description}</span>}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default ChatAccordion
